import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";

const initialState = {
  userProfile: {
    _id: "",
    userId: "",
    firstname: "",
    lastname: "",
    phoneNo: "",
    email: "",
    emailVerification: false,
    signUpDate: moment().format(),
    lastActive: moment().format(),
    password: "",
    preferences: [],
    subscriptionPlan: {},
    bots: [
      {
        _id: "",
        botName: "",
        botPicture: "",
      },
    ],
  },
  isAuthenticated: false,
  chattingID: "",
};

const userProfileSlice = createSlice({
  name: "User Profile",
  initialState,
  reducers: {
    setUserProfile: (state, { payload }) => {
      state.userProfile = payload;
    },
    setUserAuthStatus: (state, { payload }) => {
      state.isAuthenticated = payload;
    },
    setChattingID: (state, { payload }) => {
      state.chattingID = payload;
    },
  },
});

export const { setUserProfile, setUserAuthStatus, setChattingID } =
  userProfileSlice.actions;

export default userProfileSlice.reducer;
